import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import _ = require('underscore');
import { IPopupSettings } from '../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { ExtraItemModel, ExtrasFilter } from '../../core';
import { ExtrasService } from '../extras.service';

class ArchivedExtras implements ng.IController {

    public static $inject = [
        '$scope',
        '$translate',
        'notificationService',
        'extrasService',
        'popupService'];

    public model = {
        extras: [] as ExtraItemModel[],
        searchTerm: null as string,
        searchTermForEmptyScreen: null as string,
        waiting: false as boolean
    };

    public total: number = 0;
    public isSearch: boolean = false;

    public viewport = {
        width: $(window).width(),
        height: $(window).height(),
        scrollTop: 0
    };

    constructor(
        private $scope: ng.IScope,
        private $translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
        private extrasService: ExtrasService,
        private popupService: PopupService,
    ) {
    }

    public async $onInit() {
        await this.loadArchivedExtras();
        this.bindWindowEvents();
    }

    public async loadArchivedExtras() {
        if (this.model.waiting) {
            return;
        }

        if (this.total && this.model.extras.length === this.total) {
            return;
        }

        this.model.waiting = true;

        const filter: ExtrasFilter = {
            SearchTerm: this.model.searchTerm,
            Limit: 20,
            SearchAfterID: this.model.extras.length ?  _.last(this.model.extras).ID : null,
            Archived: true
        };

        this.model.searchTermForEmptyScreen = this.model.searchTerm;
        this.notificationService.showWaitingMessage();

        try {
            const extrasResponse = await this.extrasService.getExtras(filter);
            this.total  = extrasResponse.Total;
            Array.prototype.push.apply(this.model.extras, extrasResponse.Items);
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        } finally {
            this.model.waiting = false;
            this.notificationService.clearAll();
        }
    }

    public async search(searchText: string) {
        this.total = 0;
        this.model.extras = [];
        this.model.searchTerm = searchText;
        await this.loadArchivedExtras();
        this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '' ;
    }

    public async resetSearch() {
        this.model.searchTerm = '';
        this.search(this.model.searchTerm);
    }

    public async restoreExtra(extra: any) {
        try {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('cancel'),
                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('restore'),
                cancelClass: 'btn btn-with-background-icon icon-time-restore--white btn-success',
                title: this.$translate.instant('restore_extras_title'),
                content: this.$translate.instant('restore_extras_content'),
                invertAction: true,
                classPopup: 'popup--redesign modal360'
            } as IPopupSettings);
        } catch (error) {
            return;
        }

        this.notificationService.showWaitingMessage();
        this.model.waiting = true;
        try {
            await this.extrasService.restoreExtra(extra.ID);
            this.notificationService.clearAll();
            this.resetExtrasList();
            await this.loadArchivedExtras();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        } finally {
            this.notificationService.clearAll();
            this.model.waiting = false;
        }
    }

    private resetExtrasList() {
        this.model.waiting = false;
        this.model.extras = [];
        this.total = 0;
    }

    private bindWindowEvents() {
        $(window).resize(() => {
            this.viewport.width = $(window).width();
            this.viewport.height = $(window).height();
            this.$scope.$apply();
        });

        $(window).scroll(() => {
            this.viewport.scrollTop = $(document).scrollTop();
            this.$scope.$apply();
        });
    }

}

angular.module('naut').component('archivedExtras', {
    template: require('./archived-extras.component.html'),
    controller: ArchivedExtras,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/extras/archived-extras/archived-extras.component.ts